export class Clinic {
    _id: string;
    name: string;
    status: string;
    address: string;
    phone_no: string;
}
